var Aneox;
(function(Aneox) {
    (function(Controllers) {
        'use strict';

        var Vineyard = (function() {

            var self;
            var animState;
            var windowHeight;

            function Vineyard(animations) {
                self = this;
                self.timeline = animations.timeline;
            }

            Vineyard.prototype.enter = function() {
                self.timeline.call(function() { animState = { vineyard: [] }; });
                
                self.timeline.set('#vineyard', { display: 'block', opacity: 0 });
                self.timeline.set('#vineyard-aside', { display: 'block', opacity: 0 });
                self.timeline.set('#vineyard-aside .button-mask', { display: 'block', x: '0%' });

                self.timeline.set('#vineyard .mast-next', { opacity: 0 });
                self.timeline.set('#vineyard-mast h2 i', { scale: 1, opacity: 1 });
                
                self.timeline.call(self.handleWindowResize.bind(self));
                self.timeline.call(function() { $('html, body').scrollTop(0); });

                self.timeline.to('#vineyard', 0.5, { opacity: 1 });
                self.timeline.to('#vineyard-aside', 0.5, { opacity: 1 }, '-=0.5');
                self.timeline.to('#vineyard-aside .button-mask', 0.5, { x: '100%', display: 'none' });

                if (Aneox.Data.Config.runtime.supportsScrollEvents) {
                    self.timeline.set('#vineyard .content-block .vineyard-text', { opacity: 0 }, 0);

                    self.timeline.set('#vineyard .mask', { display: 'block', top: 0 }, 0);
                    self.timeline.to('#vineyard-mast .mask', 1, { top: '100%' });

                    self.timeline.call(function() {
                        if ($(window).scrollTop() !== 0) return;
                        TweenMax.fromTo('#vineyard .mast-next', 1, {opacity: 0, y: -15 }, { opacity: 1, y: 0 });
                        TweenMax.fromTo('#vineyard-mast h2 i', 1, { scale: 1, opacity: 1 }, { scale: 1.25, opacity: 0.75, yoyo: true, repeat: -1 });
                    });
                }
                
                if (self.scrollTarget) {
                    var target = 0;
                    switch (self.scrollTarget) {
                        case 'bourgogne':
                            target = 0;
                            break;
                        case 'champagne':
                            target = 1;
                            break;
                    }

                    self.timeline.call(function() {
                        $('html, body').animate({
                            scrollTop: $('#vineyard-list .content-block:eq(' + target + ')').height() - 100
                        }, 1000);
                    });

                    self.scrollTarget = undefined;
                }
            };

            Vineyard.prototype.leave = function(callback) {
                self.timeline.call(function() {
                    TweenMax.killChildTweensOf('#vineyard');
                });
                
                self.timeline.to('#vineyard', 0.5, { display: 'none', opacity: 0 });
                self.timeline.to('#vineyard-aside', 0.5, { display: 'none', opacity: 0 }, '-=0.5');

                if (callback) self.timeline.call(callback);
            };

            Vineyard.prototype.handleWindowResize = function() {
                windowHeight = $(window).height();
                
                _.forEach($('#vineyard .vineyard-illustration'), function(element) {
                    $(element).height($(element).width());
                });
            };

            Vineyard.prototype.scrollToContent = function() {
                $('html, body').animate({
                    scrollTop: $(window).height() - 100
                }, 1000);
            };

            Vineyard.prototype.handleScroll = function(event) {
                if (!Aneox.Data.Config.runtime.supportsScrollEvents) return;
                if (!animState) return;

                if (!animState.scrollArrow && $(window).scrollTop() > 0) {
                    TweenMax.killTweensOf('#vineyard .mast-next');
                    TweenMax.killTweensOf('#vineyard-mast h2 i');
                    TweenMax.to('#vineyard .mast-next', 0.5, { opacity: 0 });
                    TweenMax.to('#vineyard-mast h2 i', 0.5, { scale: 1, opacity: 1 });
                    animState.scrollArrow = true;
                }

                for (var i = 0; i < $('#vineyard-list .content-block').length; i += 1) {
                    if (!animState.vineyard[i] && $('#vineyard-list .content-block:eq(' + i + ')')[0].getBoundingClientRect().top < windowHeight * 0.5) {
                        TweenMax.to('#vineyard-list .content-block:eq(' + i + ') .mask', 1, { top: '100%' });
                        TweenMax.to('#vineyard-list .content-block:eq(' + i + ') .vineyard-text', 1, { opacity: 1, delay: 0.5 });
                        animState.vineyard[i] = true;
                    }
                }
            };
            
            Vineyard.prototype.mouseEnter = function(area) {
                if (Aneox.Data.Config.runtime.mobile) return;

                switch (area) {
                    case 'mast':
                        TweenMax.to('#vineyard .mast-next', 0.5, { y: 15 });
                        break;
                }
            };

            Vineyard.prototype.mouseLeave = function(area) {
                if (Aneox.Data.Config.runtime.mobile) return;

                switch (area) {
                    case 'mast':
                        TweenMax.to('#vineyard .mast-next', 0.5, { y: 0 });
                        break;
                }
            };

            return Vineyard;
        })();

        Controllers.Vineyard = Vineyard;
    })(Aneox.Controllers || (Aneox.Controllers = {}));
})(Aneox || (Aneox = {}));